import { IGenericEntity } from 'types/common';
import { ISegmentOption } from './types';

export const transformIGenericToISegmentOption = (item: IGenericEntity): ISegmentOption => {
	const names = [item.name, item.name_ar].filter((id) => id).join(' | ');

	return {
		label: `#${item.id} - ${names}`,
		key: `#${item.id} - ${names}`.toLowerCase(),
		value: item.id,

		object: item,
	};
};
